/**
 *
 * Styles for BypassBlock
 *
 */

import styled from "styled-components";
import {
  focusedState,
  focusedFormControlStyle,
} from "root/libs/ui-styleguide/src";
import { IconButton } from "root/libs/ui-components/src";

export const BypassBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const IconWrapper = styled(IconButton)`
  border: var(--dui-size-width-border-xs) solid var(--dui-color-gray-600);
  width: ${(props) => (props.showCopyInside === true ? "auto" : "46px")};
  height: ${(props) => (props.showCopyInside === true ? "38px" : "46px")};
  padding-left: ${(props) =>
    props.showCopyInside === true
      ? "var(--gaq-size-space-11px)"
      : "var(--dui-size-space-1)"};
  padding-right: ${(props) =>
    props.showCopyInside === true
      ? "var(--gaq-size-space-11px)"
      : "var(--dui-size-space-1)"};
  ${focusedState.focus}

  svg {
    margin-right: ${(props) =>
      props.showCopyInside === true
        ? "var(--dui-size-space-5x)"
        : "var(--dui-size-space-0)"};
  }

  &:focus {
    text-decoration: underline;
    font-weight: 800;
  }

  &:hover {
    border: ${focusedFormControlStyle};
    padding-left: ${(props) =>
      props.showCopyInside === true
        ? "var(--dui-size-space-5x)"
        : "var(--dui-size-space-0)"};
    padding-right: ${(props) =>
      props.showCopyInside === true
        ? "var(--dui-size-space-5x)"
        : "var(--dui-size-space-0)"};
  }
`;
